
import React from "react";
import TestimonialCard from "@/components/TestimonialCard";
import { Info } from "lucide-react";

const TestimonialsSection: React.FC = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Erfahrungsberichte
          </span>
          <h2 className="animate-fade-in" style={{ animationDelay: '100ms' }}>
            Was andere über das Outdoor-Coaching am Rothsee sagen
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <TestimonialCard
            content="Die Outdoor-Coaching-Session am Rothsee war ein Wendepunkt für mich. Die Kombination aus Natur, Bewegung und Jörgs einfühlsamer Begleitung hat mir geholfen, Blockaden zu lösen, die mich jahrelang zurückgehalten haben."
            author="Sarah W."
            role="Führungskraft"
            delay={0}
          />
          
          <TestimonialCard
            content="Das Walk & Talk-Format hat mir völlig neue Perspektiven auf meine finanzielle Situation eröffnet. Die entspannte Atmosphäre in der Natur half mir, leichter über schwierige Themen zu sprechen und kreative Lösungen zu finden."
            author="Thomas K."
            role="Selbstständiger"
            delay={150}
          />
          
          <TestimonialCard
            content="Ich war anfangs skeptisch, ob ein Spaziergang am See wirklich einen Unterschied machen würde. Nach der Session mit Jörg kann ich sagen: Die Verbindung von Bewegung und Coaching ist unglaublich wirksam! Meine Gedanken wurden klarer und ich konnte endlich Entscheidungen treffen."
            author="Melanie R."
            role="Angestellte"
            delay={300}
          />

          <TestimonialCard
            content="Ich hatte ehrlich gesagt wenig erwartet. Aber nach 90 Minuten am See hatte ich mehr Klarheit über eine Entscheidung, die mich seit Wochen beschäftigt hatte, als nach mehreren Meetings im Büro."
            author="Mario T."
            role="Teamleiter"
            delay={450}
          />
        </div>

        <div className="mt-8 text-sm text-joerg-500 flex items-center">
          <Info className="h-4 w-4 mr-2 text-joerg-400 flex-shrink-0" />
          <span>Aus Datenschutzgründen wurden Namen pseudonymisiert. Die beruflichen Angaben entsprechen den tatsächlichen Tätigkeitsfeldern.</span>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
